/** @format */

import React, { useState } from "react";
import Modal from "../../../generic/Modal.jsx";
import { toast } from "react-toastify";
import { CiDiscount1 } from "react-icons/ci";
import { useAddStudentDiscountMutation, useGetStudentDiscountMonthQuery } from "../../../redux/slice/students/studentsDiscount.js";
import { useTheme } from "../../context/index.jsx";

export function Discount({ ID }) {
    const { profile } = useTheme();

    const [open, setOpen] = useState(false); // Fixed the typo here
    const [createStudent, { isLoading }] = useAddStudentDiscountMutation();

    const { data:date  } =     useGetStudentDiscountMonthQuery()
    

    const [inputValue, setInputValue] = useState({
        payment: "",
        date: "",
    });
    useGetStudentDiscountMonthQuery()
    
    const addData = async (e) => {
        const formData = new FormData();
        formData.append("price", inputValue?.payment);
        formData.append("student", ID);
        formData.append("month", inputValue.date);
        formData.append("author", profile?.user?.full_type);
        try {
            await createStudent(formData).unwrap();
            toast.success(`O'quvchi Chegirmasi qo'shildi`);
            setOpen(false);
            setInputValue(
                {
                    payment: "",
                    date: "",
                }
            )
        } catch (error) {
            toast.error("O'quv  chi To'lov qo'shilmadi");
        }
    };
    const res = inputValue?.payment;
    const onClose = () => {
        setOpen(false);
        setInputValue(
            {
                payment: "",
                date: "",
            }
        )
    };

    return (
        <div className='col-span-4'>
            <button
                onClick={() => setOpen(true)}
                type='button'
                className="inline-flex items-center rounded-md bg-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-blue-400"
            >
                <CiDiscount1 className='-ml-0.5 mr-1.5 text-xl' aria-hidden='true' />
                Chegirma
            </button>
            {open && (
                <Modal
                    title={"To'lov"}
                    loader={isLoading}
                    closeModal={onClose}
                    addFunc={() => addData(ID)}>
                    <div className='grid grid-cols-2 gap-2'>
                        <div>
                            <span>Chegirirma qiymati *</span>
                            <input
                                type='text'
                                id='pulMiqdori'
                                name='sallery'
                                autoComplete='salary'
                                required
                                onChange={(e) =>
                                    setInputValue({ ...inputValue, payment: e.target.value })
                                }
                                className='block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6'
                            />
                        </div>
                        <div className="flex flex-col">
                            <span>Chegirma Muddati *</span>
                            <select onChange={(e) => setInputValue({ ...inputValue, date: e.target.value })}
                                className='block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6'
                            >
                                <option value="Hech biri">Hech biri</option>
                                {date?.map((value) => (
                                    <option value={value?.value}>{value?.key}</option>
                                ))}
                            </select>
                        </div>

                    </div>
                </Modal>
            )}
        </div>
    );
}

export default Discount;
